import { render, staticRenderFns } from "./ServiceNew.vue?vue&type=template&id=2917882b&"
import script from "./ServiceNew.vue?vue&type=script&lang=js&"
export * from "./ServiceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports